import React, { useEffect, useState } from 'react'
import Lottie from 'lottie-react'
import { useLocation } from 'react-router-dom'

import { getCommercialCombinedOptions } from '@/api/commercialCombined'
import { getMotorTradeOptions } from '@/api/motorTrade'
import { commercialCombinedOptionsFormStore } from '@/store/CommercialCombinedFormStore'
import { optionsloaderStore } from '@/store/LoaderStore'
import { motorTradeOptionsFormStore } from '@/store/MotorTradeFormStore'
import animationData from '@/assets/images/cg_loading.json'

export const DataContainer = ({
  children,
}: {
  children: React.ReactElement
}) => {
  const { setOptions: setCommercialCombinedOptions } =
    commercialCombinedOptionsFormStore()
  const { setOptions: setMotorTradeOptions } = motorTradeOptionsFormStore()
  const location = useLocation()

  const { loading, setOptionsLoading } = optionsloaderStore()
  const [fetchedCommercialCombined, setFetchedCommercialCombined] =
    useState(false)
  const [fetchedMotorTrade, setFetchedMotorTrade] = useState(false)
  const [fetchingCommercialCombined, setFetchingCommercialCombined] =
    useState(false)
  const [fetchingMotorTrade, setFetchingMotorTrade] = useState(false)

  useEffect(() => {
    const fetchCommercialCombinedOptions = () => {
      setFetchingCommercialCombined(true)
      setOptionsLoading(true)
      setTimeout(async () => {
        try {
          const response = await getCommercialCombinedOptions()
          const options = response.data
          setCommercialCombinedOptions(options)
          sessionStorage.setItem(
            'commercialCombinedOptions',
            JSON.stringify(options)
          )
          setFetchedCommercialCombined(true)
        } finally {
          setOptionsLoading(false)
          setFetchingCommercialCombined(false)
        }
      }, 300)
    }

    const fetchMotorTradeOptions = () => {
      setFetchingMotorTrade(true)
      setOptionsLoading(true)
      setTimeout(async () => {
        try {
          const response = await getMotorTradeOptions()
          const options = response.data
          setMotorTradeOptions(options)
          sessionStorage.setItem('motorTradeOptions', JSON.stringify(options))
          setFetchedMotorTrade(true)
        } finally {
          setOptionsLoading(false)
          setFetchingMotorTrade(false)
        }
      }, 300)
    }

    const commercialCombinedOptions = sessionStorage.getItem(
      'commercialCombinedOptions'
    )
    const motorTradeOptions = sessionStorage.getItem('motorTradeOptions')

    if (
      location.pathname.includes('commercial-combined') &&
      !fetchedCommercialCombined &&
      !fetchingCommercialCombined
    ) {
      if (commercialCombinedOptions) {
        setCommercialCombinedOptions(JSON.parse(commercialCombinedOptions))
        setFetchedCommercialCombined(true)
      } else {
        fetchCommercialCombinedOptions()
      }
    }

    if (
      location.pathname.includes('motortrade-roadrisks') &&
      !fetchedMotorTrade &&
      !fetchingMotorTrade
    ) {
      if (motorTradeOptions) {
        setMotorTradeOptions(JSON.parse(motorTradeOptions))
        setFetchedMotorTrade(true)
      } else {
        fetchMotorTradeOptions()
      }
    }
  }, [
    location.pathname,
    setCommercialCombinedOptions,
    setMotorTradeOptions,
    fetchedCommercialCombined,
    fetchedMotorTrade,
    fetchingCommercialCombined,
    fetchingMotorTrade,
    setOptionsLoading,
  ])

  return (
    <>
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Lottie
            animationData={animationData}
            loop
            autoplay
            style={{ height: 150, width: 150 }}
          />
        </div>
      )}
      {children}
    </>
  )
}

export default DataContainer
